common.View.create('crud::form.inputs.Url', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad() {
		this.initStripDomain();
		this.initDomainRequired();
	},

    initStripDomain()
    {
        // No domain setter found?
        if( !this.element.find('input').data('strip-domain') ) {
            return;
        }

        this.element.find('input').on('keyup', (event) => {
            let inputValue = $(event.currentTarget).val();

            let cleanInputValue = inputValue.replace('www.', '')
                .replace('http://', '')
                .replace('https://', '')
                .replace($(event.currentTarget).data('domain'), '')
                .replace(/^\//g, '');

            $(event.currentTarget).val(cleanInputValue);
        });
    },

    initDomainRequired()
    {
        // No domain setter found?
        if( !this.element.find('input').data('keep-domain') ) {
            return;
        }

        this.element.find('input').on('keyup', (event) => {
            let inputValue = $(event.currentTarget).val();

            // Not a valid url? Then show error
            if( !this.isValidHttpUrl(inputValue) ) {
                $(event.currentTarget).addClass('border border-red-400');

                if( !$('.urlValid').length )
                    $(event.currentTarget).after('<span class="urlValid block mt-1 text-red-400 text-xs">Url moet geldig zijn</span>');
            } else {
                $(event.currentTarget).removeClass('border border-red-400');

                $('.urlValid').remove();
            }
        })
    },

    isValidHttpUrl(string) {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

});
